<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯优图携AI照相馆亮相2023 ADM，探索AI与艺术结合可能性</div>
      <div class="news-date">2023年11月7日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          11月2日，第二届全球数字贸易博览会·数字消费周暨2023ADM在ADM MORE（武林之星博览中心1号厂房）开幕。作为此次数字消费周的核心活动内容，ADM为大众提供了美好生活方式多种可能性，为产业带来设计的联结价值，同时也一直在积极探索并实践数字消费新模式。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news45.png"/>
          </div>
        </div>
       <p>
        万物即设计，设计即万物。每一年，ADM都会通过对生活方式和城市文化的个性化思考，给出自己的态度标签。今年ADM的主题是“ALL IN DESIGN”，寓意通过创意展览、论坛、活动等形式，把设计创新落实到“衣食住行用”的具体细节中，让设计实现价值创造。
       </p>
       <div>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/activity/news45/news45_1.png"/>
        </div>
      </div>
      <p>
        今年，ADM联合腾讯优图实验室共同打造了
        <span class="mark-text highlight">以ADM前沿设计特色为主题的“AI照相馆”</span>
        ，观众只要在现场拍摄一张照片，就能通过腾讯优图实验室的AI融合技术将该照片进行技术合成，留下设计感满满的场景照片。值得一提的是，通过“AI照相馆”合成的照片既能保留观众本人的人脸特征，又能兼顾模板图像中人物的姿态、表情、动作等属性，而且与特定场景能够完美融合，从而使观众的整体体验过程更加丰富生动。
      </p>
      <p>作为腾讯旗下顶级的AI实验室，腾讯优图实验室自成立以来，始终聚焦AI技术研究与落地，致力于前沿技术在多行业场景的研究与落地。未来，腾讯优图实验室将继续拓展AI在各个领域的落地与应用，让AI更好地融入日常生活领域，给大家带来更多有创意有趣的互动体验。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News45',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News45.vue